const danceDrills = [
  // done 1
  {
    id: 2041,
    name: 'Beginner Movement',
    categories: ['Movement', 'beginner'],
    sports: ['dance'],
    difficulty: 'beginner',
    skill: 'Movement',
    points: 30,
    instructions:
      "Welcome, dance agent! Your mission is to master these awesome moves and bring the energy! We're going to jump, slide, and groove in this non-stop dance party. Are you ready to start the challenge? Let's go!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello, superstar! Get ready to move! Find a nice clear space on the floor! We're starting in 3... 2... 1... Let's go!",
      },
      {
        time: 10,
        text: 'Start with a light bounce! Just hop on the balls of your feet. Easy peasy! Bouncy, bouncy, bouncy! Keep it going!',
      },
      {
        time: 25,
        text: "That's it! Imagine you're super light, like a feather floating in the air! Keep bouncing!",
      },
      {
        time: 40,
        text: "Okay, let's add to it! The Super Bounce! We're gonna bounce side to side! Bounce to the right! Now bounce to the left! Right, and left! Keep it going!",
      },
      {
        time: 55,
        text: "Awesome! You look like a video game character jumping over things! Bounce left, bounce right! Don't stop moving!",
      },
      {
        time: 70,
        text: "Now let's go a little faster! Quick bounces! Right, left, right, left! Go, go, go! Fifteen more seconds of fast feet!",
      },
      {
        time: 90,
        text: "And slow it down. Just a nice easy bounce in place. Phew! Great start! Now, let's learn the Robot Arm Swing!",
      },
      {
        time: 105,
        text: 'Stand tall, and swing your arms forward and back! Keep your arms super straight! Like a robot! Beep, boop, boop!',
      },
      {
        time: 120,
        text: "Let's add our bounce back in! Bounce on your feet while you do the Robot Arm Swing! Swing and bounce, swing and bounce! Find that rhythm!",
      },
      {
        time: 140,
        text: "You got it! You're a dancing robot! Can you make your arm swings bigger? Reach forward, and reach back!",
      },
      {
        time: 155,
        text: 'Okay, Robot challenge! Swing your arms out to the side and then clap in front! Open and close! Open, clap! Open, clap! Go!',
      },
      {
        time: 170,
        text: "Yes! Keep bouncing while you do it! Open wide like you're giving a giant hug, then clap! Awesome work! Ten more seconds!",
      },
      {
        time: 185,
        text: 'Five, four, three, two, one! And stop the arms! Just keep bouncing lightly on your feet. Never stop moving! Shuffle your feet!',
      },
      {
        time: 200,
        text: "Get ready for our next move! It's super fun! The amazing Star Jump! Are you ready?",
      },
      {
        time: 210,
        text: "Here's how we do it! You squat down a little, then JUMP up, and spread your arms and legs out wide like a giant star in the sky! Let's try one! Ready? JUMP!",
      },
      {
        time: 225,
        text: "Perfect! Let's do five in a row! I'll count them! Ready? Squat down... and... one! two! three! four! five! Great Star Jumps!",
      },
      {
        time: 245,
        text: "Catch your breath, but keep bouncing on your feet! Never stand still! We're going to do another set!",
      },
      {
        time: 255,
        text: 'Another set of five Star Jumps! Make them even bigger this time! Ready? Set? Go! One! Two! Three! Four! Five! Fantastic!',
      },
      {
        time: 275,
        text: 'Okay, SPEED DRILL! How many Star Jumps can you do in 20 seconds? The clock starts... NOW! Go, go, go! Explode like a firework every time!',
      },
      {
        time: 295,
        text: "Keep pushing! You're almost there! Five, four, three, two, one! STOP! Woo! Awesome job! Just bounce it out. Shake your legs.",
      },
      {
        time: 310,
        text: "Time for our first combo! We're going to mix the Super Bounce and the Robot Arm Swing! This is gonna be fun!",
      },
      {
        time: 320,
        text: "Here's the plan! Four bounces forward with Robot Arms swinging! Then four bounces backward! Let's try it together! Ready? Go!",
      },
      {
        time: 330,
        text: 'Forward, two, three, four! And backward, two, three, four! Do it again! Forward and back!',
      },
      {
        time: 350,
        text: "You've got the rhythm! Make your robot arms super strong! And your bounces super light! Let's do two more sets without stopping!",
      },
      {
        time: 375,
        text: "Here's the last one! Forward, two, three, four! And backward, two, three, four! Amazing! Now just bounce in place. Great moves!",
      },
      {
        time: 390,
        text: "Okay dance agent, new move incoming! It's called the Super Slide! It's time to be smooth.",
      },
      {
        time: 405,
        text: "Stand with your feet together. Now take a big step to the right... and slide your other foot to meet it! Let's try it again. Step, then slide!",
      },
      {
        time: 420,
        text: "Great! Let's do four slides to the right! Ready? One, two, three, four! Now let's go left! One, two, three, four!",
      },
      {
        time: 440,
        text: "Back to the right! Go! Slide, two, three, four! And to the left! Slide, two, three, four! You're gliding across the floor!",
      },
      {
        time: 460,
        text: "Challenge time! Can you get down low while you slide? Like you're a super spy sneaking under laser beams! Try it! Slide low to the right! And low to the left!",
      },
      {
        time: 480,
        text: 'Yes! Super sneaky slides! Keep going side to side! Be as quiet as a ninja! Ten more seconds!',
      },
      {
        time: 495,
        text: 'Five, four, three, two, one! Awesome job! Come back to the middle and just bounce lightly. Shake it out!',
      },
      {
        time: 510,
        text: "Our next move is the Knee Lift March! It's super simple, but with super high energy!",
      },
      {
        time: 520,
        text: 'Just march in place, but lift your knees up REALLY high! Try to get them all the way up to your chest! Go!',
      },
      {
        time: 535,
        text: "Higher, higher, higher! Imagine you're marching over giant mountains! Lift those knees up and over!",
      },
      {
        time: 550,
        text: "Now, let's add your hands! Try to tap your knee with your opposite hand! Right hand to left knee! Left hand to right knee! It's a little tricky!",
      },
      {
        time: 565,
        text: "That's it! You got it! Keep that march going! High knees, high energy! Twenty more seconds, you can do it!",
      },
      {
        time: 585,
        text: "Let's turn it into a speed drill for the last ten seconds! Fast high knees! Go, go, go!",
      },
      {
        time: 595,
        text: 'Three, two, one! And relax. Just shuffle your feet side to side. Woo! My legs are feeling it!',
      },
      {
        time: 610,
        text: "Are you ready for Combo Number Two? We're mixing the Super Slide and the Star Jump! Let's do it!",
      },
      {
        time: 620,
        text: "Here's how it works! Two slides to the right, then one giant Star Jump! Let's practice that part! Ready? Go!",
      },
      {
        time: 630,
        text: 'Slide, slide, STAR JUMP! Awesome! Now two slides to the left, and a Star Jump! Go!',
      },
      {
        time: 645,
        text: "Slide, slide, STAR JUMP! Perfect! Let's put it all together and keep repeating it! No stopping!",
      },
      {
        time: 660,
        text: "To the right, right, JUMP! To the left, left, JUMP! Keep going! You're a dance machine!",
      },
      {
        time: 680,
        text: 'Can you make your Star Jumps even bigger? Explode into the air! Right, right, JUMP! Left, left, JUMP!',
      },
      {
        time: 700,
        text: "Let's do two more on each side! You've got this! Stay strong!",
      },
      {
        time: 720,
        text: 'Last one! To the left! Make it your best one! Go! And stop! Fantastic! Come back to the center and just bounce. You are doing amazing!',
      },
      {
        time: 740,
        text: 'Okay, time for a totally new move! The Floor Tap! This one is powerful!',
      },
      {
        time: 750,
        text: "Stand with your feet a little wide. We're going to bend our knees, and reach down to tap the floor with one hand! Then jump back up! Let's try it with your right hand. Ready? Tap the floor! And up!",
      },
      {
        time: 765,
        text: 'Great! Now with your left hand! Bend your knees, tap the floor! And up!',
      },
      {
        time: 780,
        text: "Now let's switch hands each time! Right hand tap! Then left hand tap! Keep switching! Down and up!",
      },
      {
        time: 795,
        text: 'This is a great power move! Bend those knees and tap! Keep going! Ten more seconds of practice!',
      },
      {
        time: 810,
        text: 'Okay, you know what time it is! Floor Tap SPEED DRILL! How many can you do in 20 seconds? Alternate your hands! Ready, set, go!',
      },
      {
        time: 830,
        text: "Faster, faster! Tap and pop back up! You're a superhero landing! Ten seconds left!",
      },
      {
        time: 840,
        text: 'Five, four, three, two, one! STOP! Woo! Incredible! Just march it out easy. Shake your arms.',
      },
      {
        time: 860,
        text: "Okay agent, this is it! The final challenge! The Mega Mix-Up! I'm going to call out moves, and you do them right away! Listen close!",
      },
      {
        time: 875,
        text: "Ready? Let's start with a SUPER BOUNCE! Side to side! Go!",
      },
      {
        time: 885,
        text: 'Now, ROBOT ARMS! Forward and back! Keep bouncing!',
      },
      {
        time: 895,
        text: 'Give me two SUPER SLIDES to the right! Go! Slide, slide!',
      },
      {
        time: 905,
        text: 'Three STAR JUMPS! Now! One, two, three!',
      },
      {
        time: 915,
        text: "KNEE LIFT MARCH! Get 'em up high! For ten seconds!",
      },
      {
        time: 925,
        text: 'Four FLOOR TAPS! Go! One, two, three, four!',
      },
      {
        time: 935,
        text: "And back to bouncing! Phew! That was awesome! We're going to do it all again! Get ready!",
      },
      {
        time: 950,
        text: "Let's go! ROBOT ARMS! Swing 'em!",
      },
      {
        time: 960,
        text: 'Four FLOOR TAPS! Go!',
      },
      {
        time: 970,
        text: 'KNEE LIFT MARCH! High, high, high!',
      },
      {
        time: 980,
        text: 'Two STAR JUMPS! Big ones!',
      },
      {
        time: 990,
        text: 'Four SUPER SLIDES to the left! Go!',
      },
      {
        time: 1000,
        text: "And back to the SUPER BOUNCE! Side to side! You're crushing this!",
      },
      {
        time: 1010,
        text: 'One last round! The fastest round! Listen carefully! Ready? STAR JUMP! Just one!',
      },
      {
        time: 1020,
        text: 'SLIDE LEFT! SLIDE RIGHT!',
      },
      {
        time: 1030,
        text: 'FLOOR TAP! Right hand!',
      },
      {
        time: 1035,
        text: 'FLOOR TAP! Left hand!',
      },
      {
        time: 1040,
        text: 'ROBOT ARMS! Super fast!',
      },
      {
        time: 1050,
        text: 'HIGH KNEES! Ten, nine, eight, seven, six, five, four, three, two, one! DONE!',
      },
      {
        time: 1065,
        text: 'And stop! Amazing job! Mission complete! Just walk around a little bit. Shake out your arms.',
      },
      {
        time: 1075,
        text: 'Shake out your legs! You were an amazing dance agent today! Great work!',
      },
      {
        time: 1080,
        text: '',
      },
    ],
    timeTotal: 1080,
    equipment: 'None',
  },

  // done 1
  {
    id: 2042,
    name: 'Intermediate Movement',
    categories: ['Movement', 'intermediate'],
    sports: ['dance'],
    difficulty: 'intermediate',
    skill: 'Movement',
    points: 23,
    instructions:
      "Ready to become a dance ninja?! This is a super-fast, super-fun dance game! We're gonna learn awesome new moves, put them together into secret combos, and move like a superstar. Get ready to play, let's go!",
    timedInstructions: [
      {
        time: 0,
        text: "Get ready to move! Let's start by bouncing on the balls of your feet! Nice and light, like you're on a trampoline!",
      },
      {
        time: 10,
        text: "Keep that bounce going! We're gonna play a game called Bounce and Freeze! Are you ready?",
      },
      {
        time: 20,
        text: "When I say FREEZE, you have to stop like a statue! Don't even wiggle! Okay, keep bouncing... bouncing... and... FREEZE!",
      },
      {
        time: 30,
        text: 'Perfect! Okay, start bouncing again! Go, go, go! A little faster this time! And... FREEZE!',
      },
      {
        time: 40,
        text: "You're great at this! Let's add some arms! While you bounce, swing your arms forward like a marching robot! Big circles!",
      },
      {
        time: 50,
        text: "Now swing your arms backward! Still bouncing, keep those feet moving! Let's try our freeze game with robot arms! Bounce with forward arms... FREEZE!",
      },
      {
        time: 65,
        text: 'Awesome! Go again! Bounce with backward arms... keep bouncing... and... FREEZE!',
      },
      {
        time: 80,
        text: "Okay, shake it out! Let's learn a new move! It's called the Side-Step Slide! Start shuffling your feet side to side.",
      },
      {
        time: 90,
        text: 'Take a big step to your right, and slide your other foot to meet it! Now go left! Big step left, and slide your other foot over! Right, slide! Left, slide!',
      },
      {
        time: 105,
        text: "You got it! Let's add a super loud clap! Step right, slide, CLAP! Step left, slide, CLAP! Make that clap echo!",
      },
      {
        time: 120,
        text: "Keep it up! Right, slide, CLAP! Left, slide, CLAP! You're a dancing machine!",
      },
      {
        time: 135,
        text: "COMBO TIME! Let's put our moves together! Give me four super bounces! One, two, three, four! Now two side-step claps! Right, slide, CLAP! Left, slide, CLAP!",
      },
      {
        time: 150,
        text: "Let's do that combo again! Four bounces! One, two, three, four! Two side-step claps! Right, slide, CLAP! Left, slide, CLAP! Great job!",
      },
      {
        time: 165,
        text: "SPEED DRILL! Are you ready to go super fast? Let's see how many side-step claps you can do! Ready, set, GO!",
      },
      {
        time: 180,
        text: 'Faster, faster! Quick feet, loud claps! Ten seconds left! Go, go, go! 5, 4, 3, 2, 1, STOP!',
      },
      {
        time: 195,
        text: 'Whoa! You were flying! Okay, catch your breath. March in place like a toy soldier. Get those knees up high!',
      },
      {
        time: 210,
        text: 'Alright, time for a new mission! Start bouncing on your feet again, nice and light! Get ready for the Half-Twist!',
      },
      {
        time: 225,
        text: "For the Half-Twist, you jump and turn your body to the side, then jump and turn back to the front! It's like you're a video game character! Front, side, front, other side!",
      },
      {
        time: 240,
        text: 'Keep practicing that twist! Twist right! Twist front! Twist left! Twist front! Awesome!',
      },
      {
        time: 255,
        text: 'Okay, next move is the Star Jump! You know this one! Get down low like a frog... and EXPLODE up into a giant star! Arms and legs out wide!',
      },
      {
        time: 270,
        text: "Let's do five big Star Jumps! Ready? ONE! Land softly! TWO! Get some air! THREE! BIG STAR! FOUR! ALMOST THERE! FIVE! POW!",
      },
      {
        time: 285,
        text: "NEW COMBO ALERT! Let's do four Half-Twists! Ready? Front, side, front, side! Now... one giant STAR JUMP! BOOM!",
      },
      {
        time: 300,
        text: "Let's do that combo again! Four twists, one star jump! Go! Twist, twist, twist, twist... STAR JUMP!",
      },
      {
        time: 315,
        text: "MEGA COMBO! Listen close! Two side-step claps! Two half-twists! And one giant star jump! Let's try it!",
      },
      {
        time: 325,
        text: "Ready? GO! Right slide clap, left slide clap! Twist, twist! STAR JUMP! Yes! Let's go again, a little faster!",
      },
      {
        time: 340,
        text: "Right slide clap, left slide clap! Twist, twist! STAR JUMP! You're a combo master!",
      },
      {
        time: 355,
        text: 'Incredible! Just jog in place now. Shake out your arms, shake out your legs. Catch your breath!',
      },
      {
        time: 370,
        text: "Okay, let's get back to our bounce! Keep those feet moving! Put your hands up by your face like a superhero! This is your guard!",
      },
      {
        time: 385,
        text: 'New move! The Floor Tap! While you bounce, quickly bend your knees and tap the floor with one hand! Then pop right back up!',
      },
      {
        time: 395,
        text: 'Try your right hand! Tap! Now your left hand! Tap! Keep bouncing the whole time! Right tap, pop up! Left tap, pop up!',
      },
      {
        time: 410,
        text: 'Next up is a super fun one! The Donkey Kick! Put both hands on the floor and kick both feet up behind you, like a happy donkey! Whee!',
      },
      {
        time: 425,
        text: "Be safe, but try to get your heels up high! Let's do five Donkey Kicks! One! Two! Three! Four! Five! Awesome!",
      },
      {
        time: 440,
        text: "Let's mix those up! Do a floor tap with your right hand... then a floor tap with your left hand... NOW, one big Donkey Kick!",
      },
      {
        time: 455,
        text: "Let's do that again! Right tap, left tap, DONKEY KICK! One more time! Right tap, left tap, DONKEY KICK!",
      },
      {
        time: 475,
        text: 'SPEED DRILL NUMBER TWO! How many Floor Taps can you do in 20 seconds? Go back and forth between hands! Ready, set, GO!',
      },
      {
        time: 485,
        text: 'Tap, tap, tap, tap! Super fast! Bend your knees! Keep your feet bouncing! 5, 4, 3, 2, 1, and TIME! Amazing!',
      },
      {
        time: 500,
        text: "Whew! That was fast! March in place again, catch your breath! High knees, high knees! You're doing great!",
      },
      {
        time: 515,
        text: "Okay, final round! Let's learn the Criss-Cross Knee Slap! As you march, lift your right knee and slap it with your LEFT hand!",
      },
      {
        time: 525,
        text: 'Then lift your left knee and slap it with your RIGHT hand! Criss-cross! Keep that rhythm! Slap, slap, slap, slap!',
      },
      {
        time: 540,
        text: 'Now for the best part! The Superhero Pose! Every hero needs one! When I yell POSE, you freeze in the coolest, strongest pose you can think of!',
      },
      {
        time: 555,
        text: "Let's practice! Keep doing your Criss-Cross Knee Slaps... and... POSE! Hold it! So strong!",
      },
      {
        time: 565,
        text: 'Okay, back to the knee slaps! Slap, slap, slap... ready? And... POSE! Fantastic!',
      },
      {
        time: 575,
        text: "Okay, let's try a new combo! Two Criss-Cross Knee Slaps! One, two! Now a Star Jump! BAM! Then freeze in a Superhero Pose!",
      },
      {
        time: 590,
        text: "Let's try that again! Ready? Slap, slap, STAR JUMP, POSE! Hold it!",
      },
      {
        time: 605,
        text: 'GRAND FINALE CHALLENGE! We are going to do almost every move! Listen carefully! One Side-Step Clap each way! Right and left!',
      },
      {
        time: 615,
        text: 'Then, one Half-Twist each way! Right and left!',
      },
      {
        time: 620,
        text: 'Then, one Floor Tap with each hand! Right and left!',
      },
      {
        time: 625,
        text: 'And finish with the biggest Star Jump and Superhero Pose ever! Are you ready?!',
      },
      {
        time: 635,
        text: "Let's do the whole thing! Ready? SET... GO! Side-step right, CLAP! Side-step left, CLAP!",
      },
      {
        time: 645,
        text: 'Now twist! Twist right, Twist front! Twist left, Twist front!',
      },
      {
        time: 655,
        text: 'Now the taps! Tap right, Tap left!',
      },
      {
        time: 660,
        text: 'FINISH IT! BIG STAR JUMP and... SUPERHERO POSE!',
      },
      {
        time: 670,
        text: "Hold that pose! Don't move a muscle! You are a true dance superstar! 5, 4, 3, 2, 1... YOU DID IT! AMAZING JOB!",
      },
    ],
    timeTotal: 680,
    equipment: 'None',
  },

  //done 1
  {
    id: 2043,
    name: 'Advanced Movement',
    categories: ['Movement', 'advanced'],
    sports: ['dance'],
    difficulty: 'advanced',
    skill: 'Movement',
    points: 45,
    instructions:
      "Get ready to become a dance superhero! We're going to learn awesome, super-fast moves that will make you look like a video game character! This is a speed challenge, so listen close, move your feet, and let's go!",
    timedInstructions: [
      {
        time: 0,
        text: 'Hello, superstar! Get ready for the ultimate dance challenge! Find a nice clear spot on the floor so you have room to move!',
      },
      {
        time: 10,
        text: "We're going to start by just bouncing! Bounce on the balls of your feet, nice and light! Like you're on a trampoline! Boing, boing, boing!",
      },
      {
        time: 20,
        text: "Keep bouncing! Let's get those feet moving! Shake your arms out! Wiggle your fingers! Get ready to go!",
      },
      {
        time: 30,
        text: "Okay, first move! It's called the Super Shuffle! We're gonna shuffle to the right! Ready? Take a step with your right foot, then slide your left foot to meet it. Step, slide!",
      },
      {
        time: 40,
        text: "Good! Let's try it again! To the right! Step, slide! Step, slide! You got it!",
      },
      {
        time: 50,
        text: "Now let's go LEFT! Step with your left foot, and slide your right foot to meet it. Step, slide! Keep bouncing, don't stop!",
      },
      {
        time: 60,
        text: "Awesome! Let's put it together! Two shuffles right, two shuffles left! Ready? Go! Shuffle right, shuffle right! Shuffle left, shuffle left!",
      },
      {
        time: 75,
        text: "Keep going! Right, right! And left, left! Imagine you're sliding on ice! So smooth!",
      },
      {
        time: 90,
        text: "Now let's add a CLAP! Ready? Shuffle to the right, and CLAP! Shuffle to the left, and CLAP! Let's go!",
      },
      {
        time: 105,
        text: "Shuffle, CLAP! Shuffle, CLAP! Make that clap nice and loud! You're a dancing machine!",
      },
      {
        time: 120,
        text: "Okay, SPEED DRILL! For the next 15 seconds, we're gonna do the Shuffle Clap as fast as you can! Ready, set, GO!",
      },
      {
        time: 125,
        text: 'Faster! Shuffle-clap, shuffle-clap! Go, go, go!',
      },
      {
        time: 135,
        text: "And time! Whew! Great job! Just bounce on your feet. Catch your breath for a second. But don't stop moving!",
      },
      {
        time: 150,
        text: "Let's do one more round of that Shuffle-Clap, but make it BIG! Take giant steps to the side! Giant shuffle right, CLAP! Giant shuffle left, CLAP!",
      },
      {
        time: 165,
        text: "Bigger steps! You're a giant dancing! Stomp and clap! Stomp and clap!",
      },
      {
        time: 175,
        text: 'Awesome! Back to bouncing in the middle. Shake it out!',
      },
      {
        time: 180,
        text: 'Next up, Hopscotch Jumps! Can you stand on just your right foot? Try it! Balance like a flamingo!',
      },
      {
        time: 190,
        text: 'Okay, now hop on that right foot two times! Ready? Hop, hop! Perfect! Now try your left foot. Balance...',
      },
      {
        time: 200,
        text: '...and hop two times on your left foot! Hop, hop! Easy peasy!',
      },
      {
        time: 210,
        text: 'Now, after the hops, we do a BIG jump with both feet together! Like a frog! So it goes: right foot, hop, hop, then JUMP with both feet!',
      },
      {
        time: 225,
        text: "Let's try it together, nice and slow! Right foot: hop, hop, JUMP! Awesome! Try it again! Right foot: hop, hop, JUMP!",
      },
      {
        time: 240,
        text: "Now let's do the other side! Left foot! Ready? Left foot: hop, hop, JUMP! Land with your knees bent!",
      },
      {
        time: 255,
        text: "Again! Left foot: hop, hop, JUMP! You're a hopscotch champion!",
      },
      {
        time: 270,
        text: "Let's alternate! First the right side, then the left side! Ready? Right foot, hop, hop, JUMP! Now left foot, hop, hop, JUMP!",
      },
      {
        time: 285,
        text: 'Keep that pattern going! Right side... and now the left side! Keep bouncing between moves! No stopping!',
      },
      {
        time: 300,
        text: 'SPEED DRILL! Just the jumps! Jump with both feet as fast as you can! Go! Jump, jump, jump! How many can you do in 15 seconds?',
      },
      {
        time: 315,
        text: 'Five more seconds! Faster! Three, two, one, STOP! Woo! Amazing! Just bounce. Breathe in, breathe out.',
      },
      {
        time: 330,
        text: "Okay, you're doing great! Time for a fun game! It's called Freeze Bot! We're gonna use our Super Shuffles from before.",
      },
      {
        time: 340,
        text: "I'll tell you to shuffle left or right, but when I shout FREEZE, you have to freeze in a super cool robot pose! Got it?",
      },
      {
        time: 350,
        text: "Alright, let's go! Shuffle to the right... keep shuffling... shuffle to the left... and... FREEZE! Hold that robot pose! Don't even blink!",
      },
      {
        time: 365,
        text: 'And go! Start shuffling again! Shuffle left... shuffle right... keep going... keep going... FREEZE! Strike a different pose! Maybe a superhero pose this time!',
      },
      {
        time: 380,
        text: 'And unfreeze! Go, go, go! Shuffle, shuffle, shuffle! Bounce on your feet! Move those arms!',
      },
      {
        time: 390,
        text: 'This is a tricky one! Shuffle right... shuffle left... shuffle right again... and... FREEZE! Make a silly face this time! Stick your tongue out!',
      },
      {
        time: 405,
        text: 'And go! Last round! Shuffle as fast as you can, side to side, go crazy! Move all over your space!',
      },
      {
        time: 420,
        text: 'Faster, faster, faster! And... FREEEEEEEZE! The best pose of all! Hold it! Five, four, three, two, one! Awesome!',
      },
      {
        time: 435,
        text: "Whew! That was fun! Shake it all out! Wiggle your arms, wiggle your legs! Let's get ready for the next move.",
      },
      {
        time: 480,
        text: "It's time for Ninja Kicks! These are DANCE kicks, so we're just kicking the air! Stand with your feet apart.",
      },
      {
        time: 490,
        text: "First, lift your right knee up high, like you're stepping over a big puddle. Now, from there, just flick your foot straight out in front of you! Whoosh!",
      },
      {
        time: 500,
        text: "Let's try that again! Right knee up... and KICK! Bring it right back down. Don't kick too hard, just a light flick!",
      },
      {
        time: 510,
        text: 'Now the left leg! Lift your left knee up high... and flick it out! KICK! Awesome!',
      },
      {
        time: 520,
        text: "Let's do a combo! We're going to do one shuffle to the right... and then do a Ninja Kick with your right foot!",
      },
      {
        time: 530,
        text: 'Ready? Shuffle right, and KICK! Perfect! Now shuffle left, and KICK with your left foot!',
      },
      {
        time: 540,
        text: "Let's get a rhythm! Shuffle right, KICK! Shuffle left, KICK! Imagine you're a super ninja in a movie!",
      },
      {
        time: 555,
        text: 'Make a ninja sound! Hiii-YA! Shuffle right, Hiii-YA! Shuffle left, Hiii-YA!',
      },
      {
        time: 570,
        text: 'Keep going! You look so cool! Keep your hands up in a guard, like a real ninja!',
      },
      {
        time: 585,
        text: 'Okay, SPEED DRILL! No more shuffles! Just stand in one spot and do fast Ninja Kicks! Alternating feet! Ready? Go! Kick, kick, kick, kick!',
      },
      {
        time: 600,
        text: "Faster! Light and fast! Don't stop! Ten more seconds!",
      },
      {
        time: 610,
        text: "Five, four, three, two, one, and time! Incredible! Bounce on your feet. You're a true dance ninja!",
      },
      {
        time: 630,
        text: "This next move is super fun. It's the Tornado Spin! We're going to spin all the way around!",
      },
      {
        time: 640,
        text: "Stand with your feet about shoulder-width apart. We're going to use our arms to help us spin. Swing your arms to one side, and then use that power to turn your whole body in a circle!",
      },
      {
        time: 655,
        text: "Let's try it! Swing your arms and... SPIN! Whoa! Don't get too dizzy! Try to finish facing the same way you started.",
      },
      {
        time: 670,
        text: "Let's try spinning the other way! Swing your arms the other direction and... SPIN! Awesome!",
      },
      {
        time: 680,
        text: "Okay, let's connect this to our Hopscotch Jumps! Remember? Hop, hop, JUMP!",
      },
      {
        time: 690,
        text: 'The new combo is: Hop on your right foot, hop, then JUMP with both feet... and when you land, go right into a TORNADO SPIN!',
      },
      {
        time: 705,
        text: "Let's do it together! Ready? Right foot... hop, hop, JUMP... and SPIN! Woo! How cool was that?!",
      },
      {
        time: 720,
        text: "Let's do it again! Get ready! Right foot... hop, hop, JUMP... TORNADO SPIN!",
      },
      {
        time: 735,
        text: "Now let's try it starting with the left foot! Ready? Left foot... hop, hop, JUMP... and SPIN the other way!",
      },
      {
        time: 750,
        text: "You're a dancing tornado! Let's do a few more! You choose which foot to start with! Ready? Go! Hop, hop, JUMP, SPIN!",
      },
      {
        time: 765,
        text: 'And again! One more time! Make it your best one yet! And... done! Great job! Just march in place for a second.',
      },
      {
        time: 780,
        text: 'Okay, challenge time! We are going to mix our first two moves together! The Super Shuffle and the Hopscotch Jumps!',
      },
      {
        time: 790,
        text: "Here's the combo: One Shuffle-Clap to the right! One Shuffle-Clap to the left! Then, one Hop-Hop-Jump, starting on your right foot!",
      },
      {
        time: 805,
        text: "Got it? Let's try it slow! Ready? Shuffle right, CLAP! Shuffle left, CLAP! Now, right foot... hop, hop, JUMP!",
      },
      {
        time: 820,
        text: "Perfect! Let's do it again! A little faster now! Shuffle right, CLAP! Shuffle left, CLAP! Right foot, hop, hop, JUMP!",
      },
      {
        time: 835,
        text: "Keep going! Let's do that whole combo four more times! I'll count you in! One! ...",
      },
      {
        time: 850,
        text: "Two! Keep that energy up! You're doing great!",
      },
      {
        time: 865,
        text: 'Three! Super smooth! Last one, best one!',
      },
      {
        time: 880,
        text: 'And four! AMAZING! Woo! Shake it out! We have one more big challenge!',
      },
      {
        time: 900,
        text: "Okay, superstar! Time for the second combo challenge! This time we're mixing the Ninja Kicks and the Tornado Spin!",
      },
      {
        time: 910,
        text: "Here's how it goes: One Ninja Kick with your right foot. One Ninja Kick with your left foot. Then, a TORNADO SPIN!",
      },
      {
        time: 925,
        text: "So it's Kick! Kick! Spin! Easy, right? Let's try it! Ready? Right kick, Hiii-YA! Left kick, Hiii-YA! And... TORNADO SPIN!",
      },
      {
        time: 940,
        text: "Awesome! Let's do it again! Feel the power! Kick! Kick! Spin!",
      },
      {
        time: 955,
        text: "Keep repeating it! Let's see how many you can do before I say stop! Go! Kick, kick, spin! Make your ninja face!",
      },
      {
        time: 970,
        text: 'Looking good! Make that spin super fast! But be careful!',
      },
      {
        time: 985,
        text: 'Ten more seconds! Keep the combo going! Kick! Kick! Spin!',
      },
      {
        time: 1000,
        text: 'Five, four, three, two, one, and stop! You are a combo master!',
      },
      {
        time: 1020,
        text: 'This is it! The FINAL BOSS CHALLENGE! We are going to put EVERYTHING together into one giant, super-combo!',
      },
      {
        time: 1030,
        text: 'Listen carefully! Here it is: Shuffle-Clap RIGHT! Hop-Hop-Jump with your RIGHT foot! Ninja Kick RIGHT! And a TORNADO SPIN!',
      },
      {
        time: 1045,
        text: "Whoa! Let's walk through it. Shuffle-Clap right! Then Hop-Hop-Jump! Then a Kick! Then a Spin! Let's try it SUPER slow!",
      },
      {
        time: 1060,
        text: 'Ready... and... GO! Shuffle right, CLAP! Right foot, hop, hop, JUMP! Right foot, KICK! And... TORNADO SPIN!',
      },
      {
        time: 1075,
        text: "YOU DID IT! Oh my gosh! Let's try it again! A little bit faster! GO!",
      },
      {
        time: 1090,
        text: 'One more time! The best one of the whole day! Make it amazing! Ready, set, GO!',
      },
      {
        time: 1105,
        text: 'INCREDIBLE! YOU BEAT THE FINAL BOSS! You are an official Dance Superhero! Great job today!',
      },
      {
        time: 1115,
        text: 'Wow! You did it! You completed the advanced dance challenge! You are a superstar! See you next time! Workout complete!',
      },
    ],
    timeTotal: 1125,
    equipment: 'None',
  },

  // done1
  {
    id: 2044,
    name: 'Beginner Rhythm',
    categories: ['Rhythm', 'beginner'],
    sports: ['dance'],
    difficulty: 'beginner',
    skill: 'Rhythm',
    points: 30,
    instructions:
      "Get ready for a super fun Rhythm Adventure! We're going to become body-drumming rockstars, learn awesome dance moves, and play the super fun Rhythm Freeze game! Let's make some noise and start the party!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello Rhythm Master! Get ready to make some noise and move your feet! Let's start the rhythm party! Are you ready? Let's go!",
      },
      {
        time: 10,
        text: "First, let's learn the STOMP! Just lift one foot up and STOMP it on the ground! Boom! Try it! STOMP! STOMP!",
      },
      {
        time: 20,
        text: "Awesome! Now let's find a beat! Follow me! STOMP... wait... STOMP... wait... Good! Keep your body moving! Bounce on your feet!",
      },
      {
        time: 30,
        text: "Let's try a rhythm! STOMP-STOMP... STOMP-STOMP... It's like a giant walking! BOOM-BOOM... BOOM-BOOM... Keep it going!",
      },
      {
        time: 45,
        text: "Great job! Now, let's add a CLAP! A clap is easy, just bring your hands together! CLAP! Make it loud!",
      },
      {
        time: 55,
        text: 'Okay, get ready to mix them! Stomp and clap are coming up next!',
      },
      {
        time: 60,
        text: "Here's our first big combo! We're going to do STOMP, STOMP, CLAP! Ready? Go! STOMP, STOMP, CLAP! ... STOMP, STOMP, CLAP! ... You got it!",
      },
      {
        time: 75,
        text: "This is my favorite beat! It sounds like a super famous song! STOMP, STOMP, CLAP! Keep bouncing between the beats! Don't stop moving!",
      },
      {
        time: 90,
        text: "SPEED CHALLENGE! Can you do it faster? Let's try! Ready, set, go! Stomp-Stomp-Clap! Stomp-Stomp-Clap! Stomp-Stomp-Clap! Faster!",
      },
      {
        time: 105,
        text: 'Wow! You are a speed master! Okay, slow it down. Phew! Shake out your hands! Shake out your feet!',
      },
      {
        time: 115,
        text: 'Get ready for a new sound! The LEG PAT!',
      },
      {
        time: 120,
        text: "Okay! The LEG PAT is super easy! Just pat your hands on your legs, like you're playing the drums on your knees! Pat-pat-pat-pat!",
      },
      {
        time: 130,
        text: "Let's make a rhythm! We'll do two pats, then a big CLAP! It goes: PAT-PAT... CLAP! ... PAT-PAT... CLAP! Try it with me!",
      },
      {
        time: 145,
        text: "Nice! Let's get our feet moving while we do it! March in place! March, march, march, and PAT-PAT... CLAP! ... PAT-PAT... CLAP!",
      },
      {
        time: 160,
        text: "You're a natural! Can we mix everything together? Let's try the giant beat, then the leg pat beat! Ready?",
      },
      {
        time: 170,
        text: 'Here we go! STOMP, STOMP, CLAP! ... Again! STOMP, STOMP, CLAP! Now switch! PAT-PAT... CLAP! ... Again! PAT-PAT... CLAP!',
      },
      {
        time: 180,
        text: "Let's do that again! Giant beat! STOMP, STOMP, CLAP! ... One more! STOMP, STOMP, CLAP! Now leg pat beat! PAT-PAT... CLAP! ... One more! PAT-PAT... CLAP!",
      },
      {
        time: 195,
        text: "Awesome! You're a rhythm machine! Keep bouncing on your feet! Never stand still! A rhythm master is always moving!",
      },
      {
        time: 210,
        text: "Okay, SPEED ROUND! We're going to do both beats, super fast, four times each! Are you ready for the challenge? Deep breath!",
      },
      {
        time: 220,
        text: 'GO! Stomp-Stomp-Clap! Stomp-Stomp-Clap! Stomp-Stomp-Clap! Stomp-Stomp-Clap! SWITCH! Pat-Pat-Clap! Pat-Pat-Clap! Pat-Pat-Clap! Pat-Pat-Clap!',
      },
      {
        time: 235,
        text: 'AMAZING! You did it! Okay, catch your breath! March it out! Just march your feet! Left, right, left, right!',
      },
      {
        time: 240,
        text: "Time to move around the room! Let's learn the SIDE-STEP! Stand with your feet together. Now, take a big step to the right... and bring your other foot to meet it! Clap when your feet touch!",
      },
      {
        time: 255,
        text: "Let's try it! Step right, feet together, CLAP! Step right, feet together, CLAP! It's like you're sliding!",
      },
      {
        time: 270,
        text: "Now let's go the other way! To the left! Step left, feet together, CLAP! Step left, feet together, CLAP! Keep it going!",
      },
      {
        time: 285,
        text: "Okay, let's put it together! Four to the right, four to the left! Ready? GO! One, two, three, four! Now left! One, two, three, four!",
      },
      {
        time: 300,
        text: "Let's do that again! To the right! Step-Clap! Step-Clap! Step-Clap! Step-Clap! To the left! Step-Clap! Step-Clap! Step-Clap! Step-Clap!",
      },
      {
        time: 315,
        text: "You're getting it! Now, let's try to do it to our giant beat! The rhythm is STOMP, STOMP, CLAP! So we will STEP, STEP, CLAP! Try it while moving right!",
      },
      {
        time: 330,
        text: 'Ready? Moving to the right! STEP, STEP, CLAP! Again! STEP, STEP, CLAP! Awesome! Keep shuffling your feet!',
      },
      {
        time: 345,
        text: "Now let's try it moving to the left! Get ready! Go! STEP, STEP, CLAP! Again! STEP, STEP, CLAP! Perfect!",
      },
      {
        time: 360,
        text: "Time for a new move! The RHYTHM KNEE LIFT! It's like marching, but you bring your knee up super high! Like you're stepping over a giant puddle!",
      },
      {
        time: 375,
        text: "Let's try it! Lift your right knee high! Then your left knee high! Right! Left! Right! Left! Put your hands on your hips if it helps you balance!",
      },
      {
        time: 390,
        text: "Let's add a clap! Lift your right knee and CLAP under it! Lift your left knee and CLAP under it! KNEE-CLAP! KNEE-CLAP! This one is tricky, but you can do it!",
      },
      {
        time: 405,
        text: 'Keep trying! Right knee, CLAP! Left knee, CLAP! Great job! Keep your body moving, bounce, bounce, bounce!',
      },
      {
        time: 420,
        text: "Okay, let's make a combo! We will do two side-steps to the right, then two high knee-claps! It's a dance move!",
      },
      {
        time: 430,
        text: 'Follow me! Step right, together! Step right, together! Now, high knee-CLAP! Other knee-CLAP! You did it!',
      },
      {
        time: 445,
        text: "Let's do it again! To the right! Side-step, side-step! High-knee, high-knee! Awesome!",
      },
      {
        time: 460,
        text: 'Now we have to go the other way! To the left! Ready? Side-step left, together! Side-step left, together! Now, high knee-CLAP! Other knee-CLAP!',
      },
      {
        time: 475,
        text: "Let's do it all together! Right then left!",
      },
      {
        time: 480,
        text: "To the right! Side-step, side-step, knee-clap, knee-clap! To the left! Side-step, side-step, knee-clap, knee-clap! You're a dancer!",
      },
      {
        time: 500,
        text: "Again! To the right! Go! One, two, KNEE, KNEE! To the left! Go! One, two, KNEE, KNEE! Don't stop bouncing!",
      },
      {
        time: 515,
        text: 'SPEED CHALLENGE! Can we do it a little faster? Just a little! Ready? GO! Right, right, knee, knee! Left, left, knee, knee!',
      },
      {
        time: 530,
        text: 'Keep it up! Right, right, knee, knee! Left, left, knee, knee! Amazing! Take a little break! March in place! March, march, march.',
      },
      {
        time: 540,
        text: "Okay Rhythm Master! It's time to play... RHYTHM FREEZE! It's like freeze dance, but with our moves!",
      },
      {
        time: 550,
        text: "When I say GO, you do the move I call out! Keep doing it until I shout... FREEZE! When you hear FREEZE, you have to stop and hold your position like a statue! Don't even wiggle!",
      },
      {
        time: 570,
        text: "Okay, are you ready? The first move will be... the GIANT STOMP! That's STOMP, STOMP, CLAP! Get ready to start!",
      },
      {
        time: 585,
        text: 'Three... two... one... GO! STOMP, STOMP, CLAP! Keep going! STOMP, STOMP, CLAP! Do it over and over!',
      },
      {
        time: 600,
        text: "STOMP, STOMP, CLAP! Make it loud! STOMP, STOMP, CLAP! ... FREEZE! Don't move a muscle!",
      },
      {
        time: 610,
        text: 'Okay, relax! Great freeze! The next move is... the SIDE-STEP CLAP! Ready? GO! Step-clap to the right! Step-clap to the left! Back and forth!',
      },
      {
        time: 625,
        text: 'Keep going! Slide and clap! Slide and clap! You look awesome! Keep it up... keep it up...',
      },
      {
        time: 640,
        text: 'FASTER! Side-step, side-step, side-step! ... FREEZE! Hold that pose!',
      },
      {
        time: 650,
        text: 'Excellent! Shake it out! Get ready for the next one!',
      },
      {
        time: 660,
        text: 'The next move is... the HIGH KNEE CLAP! Go! Lift a knee, clap under it! Lift the other knee, clap under it! Marching with high knees!',
      },
      {
        time: 675,
        text: "Knee-clap! Knee-clap! How high can you get your knees? Can you clap super loud? Let's hear it!",
      },
      {
        time: 690,
        text: "You've got this! Keep going! Almost there... a few more seconds... and... FREEZE! In the middle of a knee lift! Can you balance?",
      },
      {
        time: 705,
        text: 'Whoa! Great balance! Okay, you can relax! That was the last freeze! You won the game!',
      },
      {
        time: 720,
        text: "Now it's time for the ultimate test! The SUPER COMBO CHALLENGE! We're going to mix ALL our moves together into one giant rhythm!",
      },
      {
        time: 735,
        text: "Listen carefully! Here's how it goes. First, the giant beat. STOMP, STOMP, CLAP! Then, the leg pat beat. PAT-PAT, CLAP!",
      },
      {
        time: 750,
        text: "Let's just practice that part! Ready? GO! STOMP, STOMP, CLAP! ... PAT-PAT, CLAP! Let's do it again!",
      },
      {
        time: 765,
        text: 'STOMP, STOMP, CLAP! ... PAT-PAT, CLAP! Great! Now we add the next part!',
      },
      {
        time: 780,
        text: "After the PAT-PAT, CLAP... we're going to do two side-steps to the right! Step-together, step-together!",
      },
      {
        time: 790,
        text: "Let's try the whole thing from the top! Slow motion! STOMP, STOMP, CLAP! ... PAT-PAT, CLAP! ... Step right! Step right!",
      },
      {
        time: 805,
        text: "Awesome! Let's try it again! STOMP, STOMP, CLAP! ... PAT-PAT, CLAP! ... Step right! Step right!",
      },
      {
        time: 820,
        text: "There's one last part! After the side steps, we do two HIGH KNEE CLAPS! Knee-clap! Knee-clap! That's the whole thing!",
      },
      {
        time: 835,
        text: "Let's try the entire super combo! Get ready!",
      },
      {
        time: 840,
        text: 'Here we go! The Super Combo! Five, six, seven, eight! STOMP, STOMP, CLAP! ... PAT-PAT, CLAP! ... Side-step right! Side-step right! ... KNEE-CLAP! KNEE-CLAP!',
      },
      {
        time: 855,
        text: "YES! You did it! Let's do it again! And again! This is our grand finale dance!",
      },
      {
        time: 865,
        text: 'Ready? GO! Stomp, stomp, clap! Pat, pat, clap! Slide, slide! Knee, knee! Again!',
      },
      {
        time: 880,
        text: 'Stomp, stomp, clap! Pat, pat, clap! Slide, slide! Knee, knee! One more time! Make it your best one!',
      },
      {
        time: 895,
        text: 'Stomp, stomp, clap! Pat, pat, clap! Slide, slide! Knee, knee!',
      },
      {
        time: 900,
        text: "INCREDIBLE! You are a true Rhythm Master! For our last minute, we are going to do a lightning round! I'll call out a move, you do it as fast as you can!",
      },
      {
        time: 910,
        text: 'Ready? GIANT STOMPS! Go! Stomp-stomp-clap! Stomp-stomp-clap! Faster! Faster!',
      },
      {
        time: 920,
        text: 'SWITCH! SIDE-STEPS! Go! slide right, slide left, slide right, slide left! Super fast!',
      },
      {
        time: 930,
        text: 'SWITCH! HIGH KNEES! Go! Knee-clap! Knee-clap! As many as you can! Go, go, go!',
      },
      {
        time: 940,
        text: 'SWITCH! SUPER COMBO! Go! Stomp, stomp, clap, pat, pat, clap, slide, slide, knee, knee! One more time!',
      },
      {
        time: 950,
        text: 'And STOP! Wow! You did it! You completed the Rhythm Adventure! You have amazing rhythm! Give yourself a huge clap!',
      },
      {
        time: 960,
        text: 'Great job today, Rhythm Master! See you next time!',
      },
    ],
  },

  // INTERMEDIATE RHYTHM (45 minutes) DONE
  {
    id: 2045,
    name: 'Intermediate Rhythm',
    categories: ['Rhythm', 'intermediate'],
    sports: ['dance'],
    difficulty: 'intermediate',
    skill: 'Rhythm',
    points: 45,
    instructions:
      "Get ready to become a Rhythm Master! We're going to stomp, clap, and move to secret beats! Can you keep up with the challenge? Let's find out! The music is starting... NOW!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello Rhythm Master! Let's get moving right away! Start bouncing lightly on your feet! Bounce, bounce, bounce! Imagine you're on a bouncy cloud!",
      },
      {
        time: 10,
        text: "Awesome! Now, let's learn the Super Stomp! When I count, you're going to stomp your right foot! Ready? Get set...",
      },
      {
        time: 18,
        text: 'ONE! Stomp right! TWO! Bounce! THREE! Stomp right! FOUR! Bounce! Keep bouncing in between!',
      },
      {
        time: 25,
        text: "Great stomps! Let's try the other foot! The LEFT foot! Ready? ONE! Stomp left! TWO! Bounce! THREE! Stomp left! FOUR! Bounce!",
      },
      {
        time: 35,
        text: "You've got it! Now, let's alternate! We'll go RIGHT, then LEFT! Watch me! Right foot stomp! Bounce! Left foot stomp! Bounce! Your turn!",
      },
      {
        time: 45,
        text: "Right stomp! Bounce! Left stomp! Bounce! You're a stomping machine! Keep going!",
      },
      {
        time: 60,
        text: "Okay, keep bouncing on your feet! Just a light little bounce! Don't stop moving! Now, let's add the Power Clap! It's a super loud clap right in front of your chest! CLAP!",
      },
      {
        time: 70,
        text: "Let's put the stomp and the clap together! We're going to STOMP on one, and CLAP on two! Ready? And...",
      },
      {
        time: 80,
        text: "STOMP right, CLAP! Bounce, bounce! STOMP right, CLAP! Bounce, bounce! Let's go!",
      },
      {
        time: 95,
        text: "Amazing! Let's switch feet! Now it's STOMP left, CLAP! Bounce, bounce! STOMP left, CLAP! Bounce, bounce! You got this!",
      },
      {
        time: 110,
        text: 'Keep that rhythm! Stomp! Clap! Bounce! Bounce! Keep shuffling those feet! Never stand still!',
      },
      {
        time: 120,
        text: 'Okay, shake it out for a second! Wiggle your arms! Wiggle your legs! But keep bouncing! Are you ready for Combo Number One?',
      },
      {
        time: 130,
        text: "Here it is! We go: Stomp Right, Stomp Left, Clap, Clap! Got it? Let's do it slow! Ready?",
      },
      {
        time: 140,
        text: 'Stomp RIGHT! Stomp LEFT! CLAP! CLAP! Again! Stomp RIGHT! Stomp LEFT! CLAP! CLAP!',
      },
      {
        time: 155,
        text: 'A little faster now! Stomp right, stomp left, clap, clap! Stomp right, stomp left, clap, clap! Go, go, go!',
      },
      {
        time: 170,
        text: "You're a superstar! Keep doing that combo! Stomp, stomp, clap, clap! The floor is your drum!",
      },
      {
        time: 185,
        text: 'Take a little break! Just march in place! March, march, march your feet! Swing your arms like a robot!',
      },
      {
        time: 200,
        text: "New move time! It's the Side Step! We just take a big step to the right, and bring our feet together! Then a big step to the left, and bring our feet together! Try it!",
      },
      {
        time: 215,
        text: 'Step RIGHT, together! Step LEFT, together! Easy peasy! Keep going!',
      },
      {
        time: 230,
        text: "Now let's add some arms! When you step right, punch your right arm out like you're a superhero! ZAP! When you step left, punch your left arm! POW!",
      },
      {
        time: 245,
        text: 'Step RIGHT and PUNCH! Together! Step LEFT and PUNCH! Together! You look so powerful!',
      },
      {
        time: 260,
        text: "Keep it up! Right punch! Left punch! Don't stop moving your feet! Side to side!",
      },
      {
        time: 275,
        text: 'SPEED DRILL! Can you do the side step punches super fast for 15 seconds? Ready? SET! GO!',
      },
      {
        time: 290,
        text: "Three, two, one, STOP! Awesome work! March in place again! Catch your breath, you're doing great!",
      },
      {
        time: 300,
        text: 'Okay, Rhythm Master, are you ready for Combo Number Two? It uses our new side step move!',
      },
      {
        time: 310,
        text: "It goes like this: Side step RIGHT and punch! Side step LEFT and punch! Then CLAP, CLAP! Let's try it slow.",
      },
      {
        time: 320,
        text: 'Step RIGHT PUNCH! Step LEFT PUNCH! CLAP! CLAP! Again! Step RIGHT PUNCH! Step LEFT PUNCH! CLAP! CLAP!',
      },
      {
        time: 335,
        text: "Let's speed it up! Right punch, left punch, clap, clap! Right punch, left punch, clap, clap! Find the rhythm!",
      },
      {
        time: 350,
        text: "Keep going! You're a dancing machine! Don't forget to bring your feet together after each step!",
      },
      {
        time: 365,
        text: "Okay, just bounce! Bounce and shake your arms out! You've learned two amazing combos! Should we put them together?",
      },
      {
        time: 375,
        text: "THE MEGA COMBO CHALLENGE! We are going to do Combo One, and then right after, do Combo Two! It's going to be tricky, so focus!",
      },
      {
        time: 390,
        text: "Let's review! Combo one is: Stomp right, stomp left, clap, clap! Combo two is: Side step right punch, side step left punch, clap, clap!",
      },
      {
        time: 405,
        text: 'Here we go! Slow motion first! Five, six, seven, eight! Stomp RIGHT, Stomp LEFT, CLAP, CLAP! Step Right PUNCH, Step Left PUNCH, CLAP, CLAP!',
      },
      {
        time: 425,
        text: "Did you get it? Let's do it again, slow! Stomp, Stomp, Clap, Clap! Step Punch, Step Punch, Clap, Clap!",
      },
      {
        time: 445,
        text: "Okay, I think you're ready for full speed! Let's do the MEGA COMBO! Ready? GO!",
      },
      {
        time: 455,
        text: 'Stomp right, stomp left, clap, clap! Side right punch, side left punch, clap, clap! Again!',
      },
      {
        time: 470,
        text: 'Stomp, stomp, clap, clap! Step, step, clap, clap! Keep that energy up!',
      },
      {
        time: 485,
        text: "You are crushing it! Let's do it four more times! That's ONE!",
      },
      {
        time: 495,
        text: 'And TWO! Stomp, stomp, clap, clap! Step, step, clap, clap!',
      },
      {
        time: 505,
        text: "This is THREE! Don't slow down!",
      },
      {
        time: 515,
        text: 'Last one, best one! Number FOUR! Go for it!',
      },
      {
        time: 525,
        text: 'AMAZING! Great job! Now just march it out! March, march, march! You have incredible rhythm!',
      },
      {
        time: 540,
        text: "Okay, new challenge! The OFF-BEAT clap! This is tricky! We're going to clap in between the numbers! Like this: one AND two AND three AND four! Try it! Clap on the AND!",
      },
      {
        time: 555,
        text: "Let's try it with marching! March on the numbers, clap on the ANDS! March, CLAP, March, CLAP, March, CLAP, March, CLAP!",
      },
      {
        time: 570,
        text: 'This is tricky for your brain, but you can do it! Keep your feet marching and your hands clapping on the off-beat!',
      },
      {
        time: 585,
        text: "Awesome! Let's add this to a move! We are going to do our Side Step, but clap on the AND! It looks like this: Step RIGHT, CLAP, Step LEFT, CLAP!",
      },
      {
        time: 600,
        text: "The clap happens right when your feet are coming together! Let's try it! Step right, CLAP! Step left, CLAP! Go!",
      },
      {
        time: 615,
        text: "Keep going! Side to side! This is expert level rhythm! You're a genius!",
      },
      {
        time: 630,
        text: 'SPEED DRILL NUMBER TWO! Can you do the off-beat side step claps super fast for 20 seconds? Ready? GO!',
      },
      {
        time: 650,
        text: 'Faster, faster, faster! Ten more seconds!',
      },
      {
        time: 660,
        text: 'Three, two, one, DONE! Whew! Shake it out! Wiggle your whole body!',
      },
      {
        time: 675,
        text: 'Okay, time for the ultimate, final, most epic combo of all time! The Rhythm Master Finale!',
      },
      {
        time: 685,
        text: 'It has three parts! Listen carefully! Part one: Stomp right, Stomp left! Part two: Side step right punch, Side step left punch! Part three: Side step right with off-beat clap, Side step left with off-beat clap!',
      },
      {
        time: 705,
        text: "Wow! That's a big one! Let's walk through it super slow. No music, just us.",
      },
      {
        time: 715,
        text: "Ready? Stomp RIGHT. Stomp LEFT. Now, Side step RIGHT with a PUNCH. Side step LEFT with a PUNCH. Now, Side step RIGHT with a CLAP. Side step LEFT with a CLAP. That's the whole thing!",
      },
      {
        time: 735,
        text: "Let's try it again, a little faster. Stomp, Stomp! Punch, Punch! Clap, Clap! Got it?",
      },
      {
        time: 750,
        text: "Okay, I'm starting the music! Let's do the finale combo together! Five, six, seven, eight!",
      },
      {
        time: 760,
        text: 'Stomp, Stomp! Punch, Punch! Clap, Clap! Again!',
      },
      {
        time: 775,
        text: "Stomp, Stomp! Punch, Punch! Clap, Clap! You've got the beat!",
      },
      {
        time: 790,
        text: 'Keep repeating it! This is the main event! Show me your rhythm power!',
      },
      {
        time: 810,
        text: "Don't stop moving! Stomp, Stomp! Punch, Punch! Clap, Clap! Four more times! Here's ONE!",
      },
      {
        time: 825,
        text: 'And TWO! Looking good!',
      },
      {
        time: 840,
        text: 'Number THREE! Almost there!',
      },
      {
        time: 855,
        text: 'LAST ONE! MAKE IT PERFECT! GO!',
      },
      {
        time: 870,
        text: "YOU DID IT! AMAZING! Now, just jump up and down! Celebrate! You're a true Rhythm Master!",
      },
      {
        time: 885,
        text: "For our last challenge, we're going to play FREEZE DANCE! When I say go, you do ANY of the moves we learned today! The stomp! The punch! The clap! Mix them up however you want! But when I yell FREEZE... you have to freeze like a statue!",
      },
      {
        time: 900,
        text: 'Ready? Set? GO! Dance crazy! Use the moves!',
      },
      {
        time: 915,
        text: "FREEZE! Don't even blink!",
      },
      {
        time: 920,
        text: 'Okay, GO! Move those feet! Show me your rhythm!',
      },
      {
        time: 935,
        text: 'FREEZE! Hold it... hold it...',
      },
      {
        time: 940,
        text: 'GO! Last chance to dance! Go wild!',
      },
      {
        time: 955,
        text: 'Annnnnd... FREEZE! Perfect statue!',
      },
      {
        time: 960,
        text: 'Wow! You are incredible! Give yourself a giant clap! And another one! And now a super fast round of applause! You are an official Rhythm Master!',
      },
      {
        time: 975,
        text: 'Great job today! Keep practicing your new moves! See you next time!',
      },
    ],
  },

  // ADVANCED RHYTHM (45 minutes) DONE
  {
    id: 2046,
    name: 'Robot Rhythm Challenge',
    categories: ['Rhythm', 'advanced'],
    sports: ['dance'],
    difficulty: 'advanced',
    skill: 'Rhythm',
    points: 45,
    instructions:
      "Get ready to power up your circuits! Welcome to the Robot Rhythm Challenge! Your mission is to learn the coolest robot moves and put them together in an awesome dance! Can you keep up with the beat? Let's find out! Activate dance mode in 3, 2, 1!",
    timedInstructions: [
      {
        time: 0,
        text: 'Get ready! Find a nice open space so you can move around!',
      },
      {
        time: 5,
        text: "We're going to start with the Robot Bounce! Just bounce lightly on the balls of your feet. Bouncy, bouncy, bouncy! Keep your hands up like you're a cool robot guard!",
      },
      {
        time: 15,
        text: "Awesome! Keep bouncing! Let's get the rhythm! Bounce, bounce, bounce!",
      },
      {
        time: 25,
        text: "Okay, first move is the Robo-Stomp! It's easy! Just stomp your right foot, then stomp your left foot! Ready? Go! Right stomp! Left stomp!",
      },
      {
        time: 35,
        text: 'Great stomping! Now add a clap! It goes: Right stomp, Left stomp, CLAP! Try it with me! Right stomp, Left stomp, CLAP!',
      },
      {
        time: 45,
        text: "You got it! Keep doing it! Stomp, Stomp, CLAP! Stomp, Stomp, CLAP! Feel the beat! You're a stomping robot!",
      },
      {
        time: 60,
        text: 'Faster now! Stomp-Stomp-CLAP! Stomp-Stomp-CLAP! Go, go, go!',
      },
      {
        time: 75,
        text: "Amazing! Keep bouncing on your feet! Don't stop moving! Shuffle a little to the left! Now shuffle to the right!",
      },
      {
        time: 90,
        text: 'Next move is the Laser Arm! Make your right arm super straight and stiff, like a robot laser! Point it straight out in front of you! ZAP!',
      },
      {
        time: 100,
        text: 'Now pull it back! And do the left arm! Straight out! ZAP! And pull it back!',
      },
      {
        time: 110,
        text: "Let's make a rhythm! It goes: Right arm ZAP, Left arm ZAP! Ready? Go! Right ZAP! Left ZAP! Right ZAP! Left ZAP!",
      },
      {
        time: 125,
        text: "Make the moves super sharp! Like a real robot! ZAP! ZAP! Keep your other hand up in a guard! Don't get floppy!",
      },
      {
        time: 140,
        text: "Awesome! Now let's try a double zap! It goes: Right-Right-ZAP! Then Left-Left-ZAP! Try it! Right-Right-ZAP! Left-Left-ZAP!",
      },
      {
        time: 155,
        text: "You're a laser master! Keep bouncing! Never stop the bounce! Bounce, bounce, bounce!",
      },
      {
        time: 170,
        text: "Time to combine! We're going to do the Robo-Stomp and the Laser Arms together! Are you ready for this?!",
      },
      {
        time: 180,
        text: "Here's the pattern! Listen carefully! It goes: Right stomp, Left stomp, CLAP! Then, Right arm ZAP, Left arm ZAP! Got it?",
      },
      {
        time: 190,
        text: "Let's do it slow! Ready? GO! Right stomp, Left stomp, CLAP! Right ZAP, Left ZAP!",
      },
      {
        time: 200,
        text: "Again! Stomp, Stomp, CLAP! ZAP, ZAP! You're doing it! Keep going!",
      },
      {
        time: 215,
        text: "Let's speed it up a little bit! Get ready! Stomp, Stomp, CLAP, ZAP, ZAP! Stomp, Stomp, CLAP, ZAP, ZAP!",
      },
      {
        time: 230,
        text: "Fantastic! You're a natural robot dancer! Keep bouncing while I tell you the next move!",
      },
      {
        time: 245,
        text: 'The next move is the Gear Shift! Stand with your feet a little bit apart. Now, bend your knees and quickly hop your feet to the right! Then quickly hop them back to the center!',
      },
      {
        time: 260,
        text: "Let's try it! Shift RIGHT! And back to center! Now, shift LEFT! And back to center! It's like your robot legs are shifting gears!",
      },
      {
        time: 275,
        text: "Let's make a pattern! We go Right, Center, Left, Center! Try it! Right, Center, Left, Center! Keep your robot arms ready!",
      },
      {
        time: 290,
        text: "Faster! Shift-shift-shift-shift! Right, Center, Left, Center! Go go go! You're a super-fast robot!",
      },
      {
        time: 305,
        text: 'Great job! Take a quick 5 seconds to just bounce and shake it out! Wiggle your robot fingers!',
      },
      {
        time: 310,
        text: 'Okay, big combo time! We are adding the Gear Shift! This is a long one, so listen up!',
      },
      {
        time: 320,
        text: 'It goes: Stomp, Stomp, CLAP! Then, ZAP, ZAP! Then, Gear Shift Right, and Gear Shift Left! Wow!',
      },
      {
        time: 335,
        text: "Let's walk through it super slow. Ready? Right Stomp, Left Stomp, CLAP. Right Arm ZAP, Left Arm ZAP. Shift Right, Shift Left.",
      },
      {
        time: 350,
        text: "Let's try it for real! Here we go! Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right! Shift Left!",
      },
      {
        time: 365,
        text: "Again! Do it again! Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right! Shift Left! You're getting the hang of it!",
      },
      {
        time: 380,
        text: 'A little faster now! Feel the rhythm! Boom, Boom, CLAP! Zap, Zap! Woosh, Woosh!',
      },
      {
        time: 400,
        text: "Keep going! You are a rhythm machine! Don't forget to keep your moves sharp!",
      },
      {
        time: 420,
        text: 'Okay! Stop! Just bounce! Bounce on your feet! That combo was tricky, you did great!',
      },
      {
        time: 430,
        text: 'Get ready for a SPEED DRILL! We are going to do that full combo three times, as fast as you can! Ready?!',
      },
      {
        time: 440,
        text: 'THREE, TWO, ONE, GO! Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right! Shift Left! AGAIN!',
      },
      {
        time: 450,
        text: 'Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right! Shift Left! ONE MORE TIME, SUPER FAST!',
      },
      {
        time: 460,
        text: 'Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right! Shift Left! YOU DID IT! Awesome job!',
      },
      {
        time: 470,
        text: 'Okay, catch your breath but keep bouncing! Just a light bounce! We have one more new move before the final challenge!',
      },
      {
        time: 480,
        text: "It's called the System Scan! Stand with your feet together. Now, turn your head all the way to the right, like a robot scanning the room. Make a little 'boop-boop' sound if you want!",
      },
      {
        time: 495,
        text: 'Now scan all the way to the left! Keep your body frozen, only your head moves! Super smooth!',
      },
      {
        time: 505,
        text: "Let's make a rhythm with it! We go: Scan Right! Scan Left! Then two quick claps! Clap-Clap!",
      },
      {
        time: 515,
        text: "Let's try it together! Scan Right... Scan Left... Clap-Clap!",
      },
      {
        time: 525,
        text: 'Again! Scan Right... Scan Left... Clap-Clap! Awesome! You look like a real search-bot!',
      },
      {
        time: 540,
        text: 'Okay, time for the FINAL, ULTIMATE, MEGA COMBO! Are you ready for this?!',
      },
      {
        time: 550,
        text: "We're putting EVERYTHING together! Stomps, Zaps, Shifts, and the new Scan! Listen close!",
      },
      {
        time: 560,
        text: 'It goes: Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right, Shift Left! And then, Scan Right, Scan Left, Clap-Clap!',
      },
      {
        time: 575,
        text: "Whew! That's a big one! Let's try it super, super slow. Ready? Go! Stomp, Stomp, CLAP.",
      },
      {
        time: 585,
        text: 'Next part! Right arm ZAP! Left arm ZAP!',
      },
      {
        time: 595,
        text: 'Next! Shift your feet Right! Shift your feet Left!',
      },
      {
        time: 605,
        text: 'And finish it! Scan your head Right! Scan your head Left! CLAP-CLAP!',
      },
      {
        time: 615,
        text: "You did it! You learned the whole dance! Let's do it again, a little faster!",
      },
      {
        time: 625,
        text: 'Here we go! Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right, Shift Left! Scan Right, Scan Left, CLAP-CLAP!',
      },
      {
        time: 645,
        text: "Yeah! You got it! Keep going, let's do it two more times! Don't stop!",
      },
      {
        time: 655,
        text: 'Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right, Shift Left! Scan Right, Scan Left, CLAP-CLAP!',
      },
      {
        time: 675,
        text: 'Last one, best one! Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right, Shift Left! Scan Right, Scan Left, CLAP-CLAP!',
      },
      {
        time: 695,
        text: "Amazing! Just bounce! Shake out your robot arms and legs! You're a rockstar!",
      },
      {
        time: 710,
        text: "Get ready for a LEVEL UP challenge! I'm going to call out a move, and you have to do it as fast as you can until I call the next one! Keep bouncing between moves!",
      },
      {
        time: 720,
        text: 'Ready?! First up... ROBO-STOMPS! Go! Stomp, Stomp, CLAP! Stomp, Stomp, CLAP! Faster!',
      },
      {
        time: 735,
        text: 'Keep going! Five, four, three, two, one! STOP! Back to bouncing!',
      },
      {
        time: 745,
        text: 'Next challenge... LASER ARMS! Go! Right ZAP, Left ZAP! Right ZAP, Left ZAP! Sharp moves!',
      },
      {
        time: 760,
        text: "Faster, faster! You're a laser machine! Five, four, three, two, one! STOP! Back to bouncing!",
      },
      {
        time: 770,
        text: "Next up... GEAR SHIFTS! Go! Right, Left, Right, Left! Quick feet! Don't fall over!",
      },
      {
        time: 785,
        text: 'Come on, power through! Five, four, three, two, one! STOP! Bounce it out!',
      },
      {
        time: 795,
        text: "Okay, final challenge section! It's the GLITCH game! I'll shout FREEZE, you freeze! I'll shout GLITCH, you do a quick shake! Ready?",
      },
      {
        time: 810,
        text: 'Keep bouncing... get ready... FREEZE! Cool pose!',
      },
      {
        time: 815,
        text: 'GLITCH! ... Back to bouncing!',
      },
      {
        time: 820,
        text: "This time it's faster! FREEZE! ... GLITCH! ... Bounce!",
      },
      {
        time: 825,
        text: 'FREEZE! ... GLITCH! ... Bounce!',
      },
      {
        time: 830,
        text: 'FREEZE! ... GLITCH! ... Bounce! Last one! FREEZE! Hold it... hold it...',
      },
      {
        time: 840,
        text: 'GLITCH! Awesome!',
      },
      {
        time: 845,
        text: 'You have passed all the challenges! It is time for the final performance! The MEGA ROBOT OVERDRIVE!',
      },
      {
        time: 855,
        text: 'We are going to do the entire, mega combo over and over again until the timer runs out! This is your big finish!',
      },
      {
        time: 865,
        text: "Remember it? Stomp-Stomp-CLAP, ZAP-ZAP, Shift-Shift, Scan-Scan-CLAP-CLAP! Get ready to give it all you've got!",
      },
      {
        time: 875,
        text: "The music is starting! Let's go in three, two, one, GO! Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right, Shift Left! Scan Right, Scan Left, CLAP-CLAP!",
      },
      {
        time: 895,
        text: "Don't stop! Keep the rhythm! Let's go again! Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right, Shift Left! Scan Right, Scan Left, CLAP-CLAP!",
      },
      {
        time: 915,
        text: "You're a superstar robot! Can you go even faster? Try it! Push yourself!",
      },
      {
        time: 930,
        text: 'Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right, Shift Left! Scan Right, Scan Left, CLAP-CLAP!',
      },
      {
        time: 950,
        text: "Keep that energy up! You are almost at the finish line! Don't quit now!",
      },
      {
        time: 965,
        text: 'One more time with all your power! Stomp, Stomp, CLAP! ZAP, ZAP! Shift Right, Shift Left! Scan Right, Scan Left, CLAP-CLAP!',
      },
      {
        time: 985,
        text: 'Ten more seconds! Just keep bouncing and striking your favorite robot poses! Ten, nine, eight, seven...',
      },
      {
        time: 995,
        text: 'six, five, four, three, two, one! And FREEZE! Hold your final victory pose!',
      },
      {
        time: 1000,
        text: 'Mission complete! You have officially passed the Robot Rhythm Challenge! You are an amazing dancer! Great job today!',
      },
    ],
  },

  // BEGINNER CHOREOGRAPHY (30 minutes) done
  {
    id: 2047,
    name: 'Beginner Choreography',
    categories: ['Choreography', 'beginner'],
    sports: ['dance'],
    difficulty: 'beginner',
    skill: 'Choreography',
    points: 45,
    instructions:
      "Get ready to become a Dance Creator! In this adventure, we'll learn awesome dance moves like building blocks, put them together to create secret combos, and build our very own dance routine. Let's start building!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello, Dance Creator! Let's get our bodies ready to build! Find your creator stance... feet apart, knees bouncy, and standing proud!",
      },
      {
        time: 12,
        text: "Let's warm up our bodies with a gentle bounce! Wake everything up! Now, roll those shoulders back in big circles!",
      },
      {
        time: 28,
        text: "Reach for the sky... and let your arms float down. Let's get ready to fill our toolbox with awesome moves!",
      },
      {
        time: 45,
        text: "TOOLBOX TIME! Let's learn our building blocks for today! First move: the Step-touch! Just step to the side, and tap your other foot right next to it! Let's do eight of them! Go!",
      },
      {
        time: 75,
        text: "Next tool: the Chassé! It's a fun side gallop! Step-together-step! Let's do four to the right, and four to the left! Glide!",
      },
      {
        time: 105,
        text: "Next tool: the Grapevine! Remember this one? Step to the side, cross your other foot BEHIND, step side, and bring your feet together! Let's try two right, and two left!",
      },
      {
        time: 140,
        text: "Next tool: the Box Step! It's like drawing a square with your feet! Step across, step back, step to the side, step forward! Let's do one right, and one left!",
      },
      {
        time: 175,
        text: "Final tool for today: the Pivot Turn! Just step forward with one foot, and TWIST on the balls of your feet to face the other way! Let's try four of them, switching feet!",
      },
      {
        time: 205,
        text: "Toolbox is FULL! You have all the moves you need. Shake it out! Now, let's head to the Combo Kitchen to start cooking up some dances!",
      },
      {
        time: 240,
        text: "Welcome to the Combo Kitchen! Here is RECIPE A! It's an 8-count combo. It uses four Step-touches, and then you strike a cool pose for four counts!",
      },
      {
        time: 260,
        text: "Let's build it! Give me four Step-touches... remember, step to the side and tap! One, two, three, four! Now, hold a super cool pose for five, six, seven, eight!",
      },
      {
        time: 285,
        text: "Let's do Recipe A again! Four Step-touches... and a POSE! Let's add some arms this time... swing them on the step-touches!",
      },
      {
        time: 310,
        text: "Let's drill Recipe A four times in a row! This will lock it in our brains! Ready... GO! Step-touch, two, three, four... POSE, two, three, four!",
      },
      {
        time: 360,
        text: "Awesome! Recipe A is complete! You've got your first combo! Ready for the next one?",
      },
      {
        time: 390,
        text: "Next up, RECIPE B! This one is super fun. It's two Chassés to the right... then two Pivot Turns! It's an 8-count combo!",
      },
      {
        time: 410,
        text: "Let's try it slow. Two Chassés right... that's step-together-step, step-together-step! Then two Pivot Turns... step and TWIST, step and TWIST back!",
      },
      {
        time: 440,
        text: "Let's do it again, a little faster! Chassé, Chassé, Pivot, Pivot! Keep that body tall and strong!",
      },
      {
        time: 465,
        text: "Let's drill Recipe B four times in a row! Lock it in! The more we do it, the easier it gets! GO!",
      },
      {
        time: 525,
        text: 'YES! Recipe B is in the books! You are on a roll! Time for our final recipe of the day.',
      },
      {
        time: 555,
        text: 'And now, RECIPE C! This one uses the Grapevine and the Box Step! It goes: one Grapevine to the right, one Grapevine to the left, and then one Box Step!',
      },
      {
        time: 580,
        text: "Let's break it down! Grapevine to the right... side, behind, side, together! Grapevine to the left... side, behind, side, together! Then a Box Step... cross, back, side, forward!",
      },
      {
        time: 615,
        text: "Let's try Recipe C again, all smooth! Grapevine, Grapevine, Box Step! Add a clap when you finish the Box Step!",
      },
      {
        time: 645,
        text: "You know what to do! Let's drill Recipe C four times! Let's make it super sharp! GO!",
      },
      {
        time: 705,
        text: "Fantastic! All three recipes are done! You've learned three different combos! Now for a fun game!",
      },
      {
        time: 735,
        text: "It's time to play MIX AND MATCH! I'm going to call out a recipe letter, and you have to do that combo! You have to be a quick thinker! Ready?",
      },
      {
        time: 755,
        text: "Let's go! Give me... RECIPE A! That's four Step-touches and a pose! GO!",
      },
      {
        time: 775,
        text: "Now... RECIPE C! That's the Grapevine and Box Step combo! GO!",
      },
      {
        time: 795,
        text: 'How about... RECIPE B! The Chassé and Pivot Turn combo! GO!',
      },
      {
        time: 815,
        text: "Let's link two together! RECIPE A... right into RECIPE B! Go! Step-touches... then Chassés!",
      },
      {
        time: 845,
        text: "WOW! You're a combo master! Last one! RECIPE C... right into RECIPE A! Go! Grapevines... then Step-touches!",
      },
      {
        time: 885,
        text: 'Mix and Match complete! Your brain is getting a great workout!',
      },
      {
        time: 915,
        text: "Now, for the most important part of being a Dance Creator... it's YOUR turn to create!",
      },
      {
        time: 925,
        text: 'This is the CREATE-A-COMBO CHALLENGE! Your mission is to invent your own 8-count dance. You must use at least TWO different moves from our toolbox. You have 30 seconds to be the choreographer! Ready... set... CREATE!',
      },
      {
        time: 960,
        text: "5... 4... 3... 2... 1... TIME'S UP! Got your combo ready? Now, it's time to perform your masterpiece! Let's see it four times in a row! Show me what you made!",
      },
      {
        time: 1020,
        text: 'That was AMAZING! Your very own choreography! You should be so proud!',
      },
      {
        time: 1050,
        text: "Okay, creators! It's time for the GRAND FINALE! We are going to put all three of our recipes together to make one long super-dance! We'll do Recipe A, then B, then C!",
      },
      {
        time: 1070,
        text: "Let's walk through it once. A is Step-touches... B is Chassés and Pivots... C is Grapevines and a Box Step! Ready?",
      },
      {
        time: 1095,
        text: "It's showtime! Let's perform our whole dance! Give it all your energy and style! Five, six, seven, eight!",
      },
      {
        time: 1140,
        text: "Let's do it ONE MORE TIME! The best performance yet! Big smiles, sharp moves, and have fun! GO!",
      },
      {
        time: 1185,
        text: 'And... hold your final pose! You did it! You built a whole dance routine from scratch!',
      },
      {
        time: 1215,
        text: "Incredible work, Dance Creator. Time to cool our amazing bodies down. Let's start with a slow, easy sway from side to side.",
      },
      {
        time: 1235,
        text: "Take a deep breath in and reach your arms up like you're full of ideas... and let them float down as you breathe out.",
      },
      {
        time: 1255,
        text: "Let's gently roll our ankles, thanking our feet for all that fancy footwork.",
      },
      {
        time: 1275,
        text: 'Now give yourself the BIGGEST hug ever! You learned, you practiced, and you CREATED today! Open your arms wide!',
      },
      {
        time: 1295,
        text: 'For our grand finale... I want you to strike your official Dance Creator VICTORY POSE! Hold it!',
      },
      {
        time: 1315,
        text: "You were absolutely brilliant today! Keep creating! Don't forget to grab some water!",
      },
      {
        time: 1330,
        text: "Session complete. You're an amazing choreographer!",
      },
    ],
  },

  // INTERMEDIATE CHOREOGRAPHY (45 minutes) Done
  {
    id: 2048,
    name: 'Intermediate Choreography',
    categories: ['Choreography', 'intermediate'],
    sports: ['dance'],
    difficulty: 'intermediate',
    skill: 'Choreography',
    points: 30,
    instructions:
      "You've learned the basics of building dances, now it's time to level up your skills! In this Intermediate Choreography challenge, we'll work with trickier combos, add style and personality, and learn how to remix our moves to create something totally new. Let's become choreographers!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome back to the dance lab, choreographer! Let's power up. Find your stance: feet strong, core engaged, mind ready to create!",
      },
      {
        time: 10,
        text: "Let's start with a sharp march to find the beat. Now, let's immediately add some style. Can you make your march smooth like you're gliding? Now make it sharp and poppy!",
      },
      {
        time: 30,
        text: "Great! Let's open up the ADVANCED TOOLBOX. These are the moves we're building with today. Let's review them fast!",
      },
      {
        time: 45,
        text: "First tool: Step-ball-change! Remember, it's STEP, tap the BALL of your foot, then CHANGE your weight back! Give me four right, four left! Go!",
      },
      {
        time: 70,
        text: "Next tool: Pas de bourrée! The quick three steps... back-side-front! Let's do four traveling to the right! And four to the left!",
      },
      {
        time: 100,
        text: "Next tool: Three-step Turn! Three quick steps to make a full circle! Step, turn, step, and you're back! Two right, two left! Spot your front!",
      },
      {
        time: 130,
        text: 'Final tool: the Chassé! The side gallop... step-together-step! Give me four with low, smooth arms! Now four with high, sharp arms!',
      },
      {
        time: 160,
        text: "Toolbox is loaded! Let's enter the STYLE & DYNAMICS Lab. It's not just what you do, it's HOW you do it!",
      },
      {
        time: 180,
        text: "Give me a simple Step-touch... that's step to the side, tap your other foot in. Now, can you make it super BIG, like you're taking up the whole stage?",
      },
      {
        time: 200,
        text: "Awesome! Now, do the same Step-touch, but make it super SMALL and tidy, like you're in a tiny box. See the difference?",
      },
      {
        time: 225,
        text: "Let's play with texture! Give me four Chassés... remember, step-together-step... that are smooth and melty, like butter. Go!",
      },
      {
        time: 245,
        text: "Now, four Chassés that are sharp and poppy, like a robot! Hit-hit-hit! That's dynamics! Lab session complete!",
      },
      {
        time: 270,
        text: "Time for COMBO CONSTRUCTION! Let's build COMBO A. It's a tricky 8-count. It starts with two Step-ball-changes on the right... remember, step-ball-change!",
      },
      {
        time: 290,
        text: "After the two Step-ball-changes, you do one Three-step Turn to the right! That's step, turn, step! And finish with a sharp POSE!",
      },
      {
        time: 310,
        text: "Let's build it! Two Step-ball-changes... one Three-step Turn... and POSE! Let's run it! Again!",
      },
      {
        time: 340,
        text: "Now let's add style! Can you do the Step-ball-changes low and groovy, and the turn high and proud? Let's drill it four times with that dynamic! GO!",
      },
      {
        time: 390,
        text: "Combo A is complete! Great work. Now for COMBO B. It's another 8-count that travels.",
      },
      {
        time: 410,
        text: 'It starts with two Chassés to the right... step-together-step! Then, one Pas de bourrée to the left... back-side-front!... to change directions!',
      },
      {
        time: 435,
        text: "Let's try that! Two Chassés right... one Pas de bourrée left! It's a figure-eight pattern! Again!",
      },
      {
        time: 460,
        text: "Let's add dynamics! Make the Chassés BIG and floaty, and the Pas de bourrée SMALL and sharp! Let's drill Combo B four times! GO!",
      },
      {
        time: 510,
        text: 'Combos are built! Now for the really fun part... THE REMIX CHALLENGE!',
      },
      {
        time: 530,
        text: "First, let's remix COMBO A! The original is two Step-ball-changes, then a Three-step turn. Can you do it IN REVERSE? Start with the POSE, then the turn, then the two step-ball-changes! Let's try it!",
      },
      {
        time: 570,
        text: "Wow, your brain is working hard! Okay, now let's remix COMBO B! The original is two Chassés right, one Pas de bourrée left. Your challenge: Change the DIRECTION! Can you make the whole combo travel FORWARD instead of sideways? Get creative! GO!",
      },
      {
        time: 615,
        text: "You're not just a dancer, you're a remix artist! Remix Challenge complete!",
      },
      {
        time: 645,
        text: 'Welcome to the CHOREOGRAPHY LAB. This is where you become the creator. I will give you a prompt, and you will create a dance.',
      },
      {
        time: 660,
        text: "Your prompt today is: 'A sudden change.' You must create a new 8-count combo that has a surprising change in speed or style. Maybe it starts slow and suddenly gets fast, or starts sharp and becomes smooth.",
      },
      {
        time: 680,
        text: "You have 45 seconds to invent your 'sudden change' combo. Use any moves from our toolbox. Ready... set... CREATE!",
      },
      {
        time: 725,
        text: "5... 4... 3... 2... 1... TIME'S UP! Got your creation? Now, it's your world premiere! Perform your combo for me four times in a row! Show me your story! GO!",
      },
      {
        time: 785,
        text: 'That was brilliant! You told a story with movement! Lab session complete!',
      },
      {
        time: 815,
        text: "It's time for the DIRECTOR'S CUT! We're going to perform our full routine: Combo A, then Combo B, linked together! A is the Step-ball-change turn... B is the Chassé Pas de bourrée!",
      },
      {
        time: 840,
        text: "This is YOUR version. You choose the dynamics. Is it sharp? Is it smooth? Is it big or small? Show me your style! Let's run the Director's Cut three times! Five, six, seven, eight!",
      },
      {
        time: 915,
        text: "Last time, best time! This is your final performance! Give it everything you've got! And hold that final pose with pride!",
      },
      {
        time: 960,
        text: 'And... CUT! That was a masterpiece! Incredible work, choreographer.',
      },
      {
        time: 980,
        text: 'Time to cool down the studio. Start a slow, easy sway. Let your breath return. Let your mind relax.',
      },
      {
        time: 1000,
        text: 'Take a deep breath in, gathering all that creative energy... and exhale, letting it all go. You were amazing.',
      },
      {
        time: 1020,
        text: "Let's do a gentle quad stretch. Grab one foot and feel the stretch in the front of your leg. Hold it.",
      },
      {
        time: 1035,
        text: 'And switch sides. Thank your legs for all that complex work.',
      },
      {
        time: 1050,
        text: "Give yourself a huge hug. You didn't just dance today, you created, you remixed, and you directed!",
      },
      {
        time: 1065,
        text: 'For your grand finale... strike your official Head Choreographer VICTORY POSE! Hold it!',
      },
      {
        time: 1080,
        text: "Amazing work in the lab today! Keep creating! Don't forget to get some water!",
      },
      {
        time: 1095,
        text: "Session complete. You're an incredible choreographer!",
      },
    ],
  },

  // ADVANCED CHOREOGRAPHY (45 minutes) Done
  {
    id: 2049,
    name: 'Advanced Choreography',
    categories: ['Choreography', 'advanced'],
    sports: ['dance'],
    difficulty: 'advanced',
    skill: 'Choreography',
    points: 45,
    instructions:
      "You've proven yourself as a creator. Now, it's time to step into the role of Lead Choreographer. In this advanced session, we'll master complex sequences, deconstruct and rebuild them like a pro, and perform a truly unforgettable piece of dance. The studio is yours. Let's create.",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome, Choreographer. The studio is ready. Assume your stance: centered, focused, and prepared to command the space. Let's begin activation.",
      },
      {
        time: 15,
        text: 'Pro-level activation sequence, begin! Eight Step-touches... step to the side and tap your other foot in! Four Chassés... step-together-step, gliding sideways! Two Grapevines... step side, cross behind, step side, bring it together! Execute!',
      },
      {
        time: 45,
        text: 'Continue activation! Four Step-ball-changes... step, tap the ball of your foot, change weight back! Four Pas de bourrées... step back, side, then front! Two Three-step Turns... take three quick steps to make a full circle! No stopping! GO!',
      },
      {
        time: 80,
        text: "Activation complete. Your body is warm and your toolbox of moves is open. Let's start building our first combo.",
      },
      {
        time: 100,
        text: "COMBO A CONSTRUCTION! This is a 16-count phrase with specific LEVEL changes. Let's build it. The first 8 counts: Two LOW Chassés to the right... perform your step-together-step deep in your knees!",
      },
      {
        time: 125,
        text: "Immediately after the low Chassés, you'll do one HIGH Three-step Turn to the left... that's step-turn-step on the balls of your feet, reaching for the ceiling! And hold a high pose for two counts!",
      },
      {
        time: 150,
        text: "Let's drill that first 8! Two LOW Chassés right, one HIGH Three-step turn left, POSE! Again! Low, low, high, high, POSE!",
      },
      {
        time: 180,
        text: 'The second 8 counts of Combo A: A LOW Grapevine to the right... side, behind, side, together, staying low! Then, POP up for two sharp Pivot turns... step forward and twist halfway around! Finish with a final POSE!',
      },
      {
        time: 215,
        text: "Let's connect all of Combo A! Low Chassés, high Turn, Pose... low Grapevine, pop-up Pivots, Pose! Let's run it three times! GO!",
      },
      {
        time: 275,
        text: 'Combo A is locked! Now for COMBO B! This 16-count phrase travels on a specific PATHWAY.',
      },
      {
        time: 295,
        text: 'The first 8 counts: Two Step-ball-changes... step-ball-change!... traveling on a FORWARD right diagonal! Then, two more Step-ball-changes traveling on a BACKWARD left diagonal!',
      },
      {
        time: 330,
        text: 'The second 8 counts: A Box Step right where you are... cross, back, side, forward! Then, two Pas de bourrées... back-side-front!... that travel you straight back to where you started!',
      },
      {
        time: 365,
        text: "Let's put Combo B together! Diagonal forward Step-ball-changes... diagonal back Step-ball-changes... Box Step in place... travel back with Pas de bourrées! Run it three times! GO!",
      },
      {
        time: 425,
        text: "Excellent work. Now for a true test of a choreographer's mind... THE RETROGRADE CHALLENGE!",
      },
      {
        time: 440,
        text: 'Retrograde means to perform a phrase backwards. We will retrograde the first 8 counts of Combo A. Listen carefully. The phrase was: LOW Chassé right, LOW Chassé right, HIGH Three-step Turn left, POSE.',
      },
      {
        time: 465,
        text: "To go backwards, we start with the POSE! Then, the move before that was the turn, so we do a Three-step Turn to the RIGHT to reverse it! That's step-turn-step!",
      },
      {
        time: 485,
        text: "The moves before that were two LOW Chassés to the RIGHT. To reverse them, we do two LOW Chassés to the LEFT! Let's try the full retrograde: POSE... Three-step Turn RIGHT... Chassé LEFT... Chassé LEFT! Let's try it!",
      },
      {
        time: 525,
        text: "That's a tough mental workout! Great job! Let's build our final combo.",
      },
      {
        time: 545,
        text: "COMBO C CONSTRUCTION! This 16-count phrase is a RHYTHMIC challenge. First 8: Four slow marches forward. While you march, your hands will clap a fast sixteenth-note rhythm! That's four quick claps... ONE-e-and-a... for every one step!",
      },
      {
        time: 580,
        text: "The second 8 counts: Four slow marches backward. While you march back, your hands will clap a triplet rhythm on each step! That's three claps... TRI-PLE-LET... for every one step! Let's try it!",
      },
      {
        time: 615,
        text: "Let's put Combo C together! March forward with sixteenth-note claps... march backward with triplet claps! Run it three times! Focus on that timing! GO!",
      },
      {
        time: 675,
        text: 'All three combos are built! Now, we put them together in the PROGRESSIVE ADD-ON REHEARSAL!',
      },
      {
        time: 690,
        text: "First, let's link A and B. Run Combo A... the low and high one... right into Combo B... the diagonal one! GO!",
      },
      {
        time: 740,
        text: "Great! Now, let's add C! We will perform the entire 48-count routine! A, then B, then C, with no stops! From the top! Let's get it!",
      },
      {
        time: 810,
        text: "Let's drill the full A+B+C routine one more time to lock it into your memory! This is our masterpiece! Execute!",
      },
      {
        time: 880,
        text: "The choreography is SET. It's time for the GRAND FINALE performance!",
      },
      {
        time: 895,
        text: "We will perform the entire routine, A through C, two times. This is your moment to shine! Full energy, full focus, full performance! Let's start by facing the front!",
      },
      {
        time: 915,
        text: 'PLACES! Five, six, seven, eight!',
      },
      {
        time: 990,
        text: 'That was incredible! For our ENCORE, turn to face the right diagonal! Perform the entire show one more time, even bigger and with more power! GO!',
      },
      {
        time: 1065,
        text: 'And hold your final pose! Take it in! You just performed a complex, multi-part routine! Amazing!',
      },
      {
        time: 1085,
        text: 'Time for your ARTISTIC DECOMPRESSION. The show is over. Let the energy settle. Start with a slow, proud walk in a circle.',
      },
      {
        time: 1105,
        text: 'Come to the center. Take a deep breath in, and as you exhale, take a deep, respectful bow. Thank your body for its incredible work.',
      },
      {
        time: 1125,
        text: "Let's do a gentle quad stretch. Grab one foot and feel the stretch in the front of your leg. You asked a lot of your muscles today.",
      },
      {
        time: 1140,
        text: 'And switch sides. Breathe deeply.',
      },
      {
        time: 1155,
        text: 'Give yourself a huge, well-deserved hug. You worked at a professional level today, learning and executing complex choreography.',
      },
      {
        time: 1170,
        text: 'For your final moment, strike a pose that represents you as a choreographer. Strong, creative, and in control. Hold it.',
      },
      {
        time: 1185,
        text: "Mission accomplished. The studio is clear. Don't forget to hydrate.",
      },
      {
        time: 1200,
        text: 'Session complete. Your artistry was outstanding.',
      },
    ],
  },

  // COMPLETE INDIVIDUAL DANCE (60 minutes) Done
  {
    id: 2050,
    name: 'Complete Individual Dance',
    categories: ['Complete', 'advanced'],
    sports: ['dance'],
    difficulty: 'advanced',
    skill: 'Complete',
    points: 60,
    instructions:
      "This is it! The moment you've been training for. Welcome to your Grand Finale Performance! In this session, we'll combine all your movement, rhythm, and choreography skills into one epic dance routine. The music is on, the lights are up... it's showtime!",
    timedInstructions: [
      {
        time: 0,
        text: "Welcome to the main stage! It's showtime! Let's get into our opening positions... feet strong, body energized, mind focused. This is your moment!",
      },
      {
        time: 15,
        text: "Let's begin the DANCER'S WARM-UP! Start with a sharp march in place... lifting each foot to the beat! Now add shoulder pops on every beat! Pop your shoulders forward, right and left! Wake up that body!",
      },
      {
        time: 35,
        text: 'Keep marching! Now, let your hands clap a syncopated rhythm on top... ONE... two-AND... THREE... four-AND! Your feet and hands are in different worlds!',
      },
      {
        time: 55,
        text: "Let's move! Four Step-touches... step to the side and tap your other foot in!... into four Chassés... step-together-step, gliding sideways! Travel with purpose! GO!",
      },
      {
        time: 80,
        text: 'Now, four Step-ball-changes... step, tap the ball of your foot, change weight back!... into two big Three-step Turns... take three quick steps to make a full circle! Control and power!',
      },
      {
        time: 110,
        text: "Let's flow through our isolations! A smooth roll down the body... pop your shoulders, slide your ribs, hit your hips! And roll it back up... hips, ribs, shoulders! Again, make it fluid!",
      },
      {
        time: 140,
        text: "Warm-up complete! You're ready. Let's start building the show. Places for ACT I!",
      },
      {
        time: 160,
        text: "ACT I is called 'The Smooth Groove.' It's a 16-count phrase. The first 8 counts: One Grapevine to the right... step side, cross behind, step side, bring your feet together!",
      },
      {
        time: 180,
        text: "Right after the Grapevine, do a Pas de bourrée to the left... step back, side, then front!... which flows into a smooth Three-step Turn to the left... three quick steps in a circle! Let's drill that: Grapevine right, Pas de bourrée left, Three-step turn left! GO!",
      },
      {
        time: 215,
        text: "The second 8 counts of Act I: Two slow, melty lunges side to side... bend one knee and stretch the other leg! ... then four quick hip isolations... pop your hips right-left-right-left! It's all about texture!",
      },
      {
        time: 240,
        text: "Let's put all of Act I together! Grapevine, Pas de bourrée, Turn... two lunges, four hip pops! Let's rehearse it three times! Make it silky smooth! GO!",
      },
      {
        time: 300,
        text: 'Act I is looking great! Now, get ready for a change of energy. Places for ACT II!',
      },
      {
        time: 320,
        text: "ACT II is 'The Sharp Hits.' A different 16-count phrase. The first 8: Two Step-ball-changes right... step, ball, change!... then two sharp Pivot turns... step forward and twist halfway around!",
      },
      {
        time: 350,
        text: "Let's drill that first part! Two sharp Step-ball-changes, two sharp Pivots! Hit every beat! Again!",
      },
      {
        time: 380,
        text: 'The second 8 counts of Act II: A Box Step to the left... step across, back, side, forward!... followed by two low kicks... kick right, kick left! ... and a final sharp POSE!',
      },
      {
        time: 410,
        text: "Let's rehearse all of Act II! Step-ball-changes, Pivots, Box Step, Kick, Kick, POSE! Three times through! Make every move pop! GO!",
      },
      {
        time: 470,
        text: 'Excellent! Two acts are done. Time for our final and most challenging piece... ACT III!',
      },
      {
        time: 490,
        text: "ACT III is 'The Rhythm Code.' The first 8 counts: A Step-touch to the right... step side, tap in!... then a Step-touch to the left. Now, listen! Two triplet claps... TRI-PLE-LET, TRI-PLE-LET! And a stomp-stomp finish!",
      },
      {
        time: 520,
        text: "Let's drill that first part! Step-touch right, Step-touch left, TRI-PLE-LET, TRI-PLE-LET, STOMP-STOMP! Again!",
      },
      {
        time: 550,
        text: "The second 8 counts: A Hemiola body percussion pattern! It goes PINE-AP-PLE... tap your legs three times!... PINE-AP-PLE... tap them three times again!... PIZ-ZA... clap twice! That's a 3-3-2 rhythm! Let's try it! Pat-pat-pat, Pat-pat-pat, Clap-Clap!",
      },
      {
        time: 585,
        text: "Let's put all of Act III together! Step-touch, Step-touch, Triplets, Stomps... then the Hemiola pattern! Rehearse it twice! GO!",
      },
      {
        time: 630,
        text: "All three acts are learned! It's time for the DRESS REHEARSAL! We're connecting Act I, Act II, and Act III into one giant routine! Let's run it from the top to lock it in!",
      },
      {
        time: 655,
        text: 'From the top! Act I... Grapevine... Pas de bourrée... Turn... Lunges... Hips! Go!',
      },
      {
        time: 685,
        text: 'Into Act II! Step-ball-changes... Pivots... Box Step... Kicks... Pose!',
      },
      {
        time: 715,
        text: 'Into Act III! Step-touches... Triplets... Stomps... Hemiola! And FINAL POSE!',
      },
      {
        time: 745,
        text: "Let's run the Dress Rehearsal one more time! Fix any wobbly spots! Make it perfect! From the top, let's go!",
      },
      {
        time: 805,
        text: "Excellent! The dance is set. Now, as the director, you get to make some choices. Welcome to the DIRECTOR'S BOOTH!",
      },
      {
        time: 820,
        text: "Challenge #1: DYNAMICS! Let's perform the entire routine, but I want you to make Act I... The Smooth Groove... extra soft and sneaky. Then make Act II... The Sharp Hits... extra loud and proud! GO!",
      },
      {
        time: 880,
        text: "Challenge #2: PATHWAYS! Let's do the whole routine again, but this time you must travel! On Act I, travel on a forward diagonal to the right! On Act II, travel backwards to your starting spot! Use your space!",
      },
      {
        time: 940,
        text: "Okay, take a deep breath. Shake out the nerves. The audience is waiting. It's time for... THE GRAND FINALE!",
      },
      {
        time: 960,
        text: 'This is the final performance of the whole dance! Full energy, full passion, full style! From the top, all the way through! This is it!',
      },
      {
        time: 975,
        text: 'PLACES! Five, six, seven, eight!',
      },
      {
        time: 1050,
        text: "That was incredible! Don't stop now! The crowd wants an ENCORE! Perform the entire show one more time, even bigger and better! GO!",
      },
      {
        time: 1125,
        text: 'Hold that final pose! Take it in! You did it! What a performance!',
      },
      {
        time: 1145,
        text: "It's time for THE FINAL BOW. The performance is over. Let's cool down and celebrate. Start with a slow, proud walk in a circle.",
      },
      {
        time: 1165,
        text: 'Come to the center of your stage. Take a deep breath in... and as you exhale, take a deep, respectful bow. Thank your body for its hard work.',
      },
      {
        time: 1185,
        text: "Let's do a gentle stretch. Reach your arms up high, then swan dive down and hang, releasing all the tension from the performance.",
      },
      {
        time: 1205,
        text: 'Slowly roll up to standing. Give yourself a huge round of applause. You were a true artist today.',
      },
      {
        time: 1220,
        text: 'For the last time, strike the final pose from your performance. Your victory pose. Hold it. You are a complete dancer.',
      },
      {
        time: 1235,
        text: 'Amazing job. The show is over. Go get some water and celebrate!',
      },
      {
        time: 1250,
        text: 'Session complete. Your performance was unforgettable.',
      },
    ],
  },
];

export default danceDrills;
